import * as React from 'react';
import { ArticleHeading2, Image, UIText1 } from '@cian/ui-kit';

import { ListWithIcons } from '../../../ListWithIcons';
import { X2_IMAGE_SIZE_MEDIA_QUERY } from '../../../../constants/mediaQueries';
import { IBonus } from '../../../../types/promoInfo';

import * as styles from './styles.css';

interface IBonusCardExtendedProps {
  bonus: IBonus;
  onBonusClick: (bonus: IBonus) => void;
}

export const BonusCardExtended: React.FC<IBonusCardExtendedProps> = props => {
  const { bonus, onBonusClick } = props;

  return (
    <section className={styles['bonus']}>
      <div className={styles['text-content']}>
        <ArticleHeading2 as="h3">{bonus.title}</ArticleHeading2>
        <div className={styles['details']}>
          <ListWithIcons.List>
            {bonus.details.map((detail, i) => (
              <ListWithIcons.Item key={i}>
                <UIText1>{detail}</UIText1>
              </ListWithIcons.Item>
            ))}
          </ListWithIcons.List>
        </div>
        <button
          type="button"
          className={styles['button']}
          onClick={() => onBonusClick(bonus)}
          data-testid="bonus-info-btn"
        >
          <UIText1 fontWeight="bold" color="primary_100">
            Подробнее
          </UIText1>
        </button>
      </div>
      {bonus.image && (
        <div className={styles['image']}>
          <Image
            height="300px"
            display="block"
            objectFit="contain"
            sources={[{ media: X2_IMAGE_SIZE_MEDIA_QUERY, srcset: bonus.image.x2 }, { srcset: bonus.image.x1 }]}
            src={bonus.image.x1}
            alt={`Циан.Сделка – ${bonus.title}`}
            loading="lazy"
          />
        </div>
      )}
    </section>
  );
};
